export default {
  SIGN_UP: 'SIGN_UP',

  SIGN_IN: 'SIGN_IN',

  LOGOUT: 'LOGOUT',

  REFRESH: 'REFRESH',

  RESET_PASSWORD: 'RESET_PASSWORD',

  RECOVER_PASSWORD: 'RECOVER_PASSWORD',

  CONFIRM_EMAIL: 'CONFIRM_EMAIL',

  CHECK_AUTH: 'CHECK_AUTH',
};
